<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title *ngIf="idMdaEncontro">{{'Finalizar Encontro' | translate}}</ion-title>
    <ion-title *ngIf="!idMdaEncontro">{{'Adicionar Histórico' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content class="forms-validations-content">
  <div class="gradient-extendido"></div>

  <div class="div-top" *ngIf="!idMdaEncontro">
    <ion-note slot="start">
      <i class="fas fa-list-alt"></i>
    </ion-note>
    <ion-label> {{'Dados do histórico' | translate}} </ion-label>
  </div>

  <form
    class="sample-form validations-form"
    [formGroup]="validations_form"
    (ngSubmit)="onSubmit(validations_form.value)"
  >
    <ion-list class="ion-padding-start ion-padding-end" [ngClass]="{ 'margin-top': idMdaEncontro }">
      <div class="border-bottom">
        <prover-datepicker
          [labelName]="'Data'"
          [id]="'dateTime'"
          [(dateTime)]="dateTime"
          formControlName="data"
          [required]="true"
          [disabled]="validations_form.get('data')?.disabled ?? false"
        ></prover-datepicker>
      </div>

      <ion-item class="border-bottom" lines="none">
        <div class="div-textarea">
          <ion-label>
            {{'Resumo' | translate}}
            <span class="danger" *ngIf="userProvider.hasConfig(98)">*</span>
          </ion-label>
          <ion-textarea
            placeholder="{{'Anotações do acompanhamento' | translate}}"
            rows="5"
            type="text"
            formControlName="resumo"
            aria-label="Resumo"
          ></ion-textarea>
        </div>
      </ion-item>

      <div class="validation-errors">
        <ng-container *ngFor="let validation of validation_messages.resumo">
          <div
            class="error-message ion-margin-start"
            *ngIf="validations_form.get('resumo')?.hasError(validation.type) &&
                  (validations_form.get('resumo')?.dirty || validations_form.get('resumo')?.touched)"
          >
            {{ validation.message }}
          </div>
        </ng-container>
      </div>

      <ion-item class="ion-align-items-center border-bottom" lines="none" *ngIf="idMdaEncontro">
        <ion-select
          label-placement="stacked"
          interface="action-sheet"
          cancelText="{{ 'Cancelar' | translate}}"
          (ionChange)="mudarStatus($event)"
          okText="{{ 'Confirmar' | translate}}"
          formControlName="status"
        >
          <div slot="label" class="slot-label">{{'Status' | translate}}  <span class="danger">*</span></div>
          <ion-select-option *ngFor="let status of statusList" [value]="status.id">{{status.nome}} </ion-select-option>
        </ion-select>
      </ion-item>

      <div *ngIf="idMdaEncontro" class="validation-errors">
        <ng-container *ngFor="let validation of validation_messages.status">
          <div
            class="error-message"
            *ngIf="validations_form.get('status')?.hasError(validation.type) && validations_form.get('status')?.dirty"
          >
            {{ validation.message }}
          </div>
        </ng-container>
      </div>

      <div class="validation-errors ion-margin-start">
        <ng-container *ngIf="validations_form.get('status')?.hasError('notAllowed')">
          <ion-text color="danger" class="error-message"> Você não tem permissão para desmarcar um encontro </ion-text>
        </ng-container>
      </div>

      <ion-item class="border-bottom" lines="none">
        <ion-label>{{'Vincular Ocorrência' | translate}}</ion-label>
        <ion-toggle
          slot="end"
          [enableOnOffLabels]="true"
          aria-label=""
          formControlName="vincularOcorrencia"
          (ionChange)="toggleEvent($event)"
        ></ion-toggle>
      </ion-item>

      <ion-item *ngIf="vincularOcorrencia" class="border-bottom" lines="none">
        <ion-select
          label-placement="stacked"
          interface="action-sheet"
          cancelText="{{ 'Cancelar' | translate}}"
          okText="{{ 'Confirmar' | translate}}"
          formControlName="ocorrencia"
        >
          <div slot="label" class="slot-label">{{'Ocorrência' | translate}}</div>
          <ion-select-option *ngFor="let tipo of tipoOcorrencias" [value]="tipo">{{tipo.nome}}</ion-select-option>
        </ion-select>
      </ion-item>
    </ion-list>

    <ion-row class="d-flex ion-margin-top">
      <ion-col size="8" class="d-flex">
        <ion-button
          class="btn-success btn-custom"
          expand="block"
          type="submit"
          [disabled]="!validations_form.valid || disabled"
        >
          {{'Salvar' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>
  </form>
</ion-content>
